import type { ReactNode } from 'react'

import { useTheme } from '@emotion/react'

import { StepperConfigProvider } from './stepper-config.context'
import * as styles from './stepper.styles'

export type StepperVariant = 'horizontal' | 'vertical'

type Props = {
  backgroundColor?: string
  children: ReactNode
  className?: string
  connectorColor?: string
  iconRingColor?: string
  inverse?: boolean
  variant?: StepperVariant
}

export const Stepper = ({
  backgroundColor,
  children,
  className,
  connectorColor,
  iconRingColor,
  inverse,
  variant = 'vertical',
}: Props) => {
  const { palette } = useTheme()

  return (
    <div
      className={className}
      css={[styles.container, styles.variant[variant]]}
      data-testid="stepper"
    >
      <StepperConfigProvider
        backgroundColor={backgroundColor ?? palette.background.main}
        connectorColor={connectorColor}
        iconRingColor={iconRingColor}
        inverse={inverse}
        variant={variant}
      >
        {children}
      </StepperConfigProvider>
    </div>
  )
}
